export default __webpack_public_path__ + "static/media/valentina.ceb9122c.jpg";